module.exports = __webpack_public_path__ + "static/media/wash3.b445cca6.jpg";